import { SecondaryShell } from '@/app/layout/SecondaryShell';
import { SettingsNav } from '@/features/settings/SettingsNav';

/**
 * The shell for `/settings/*` (§ Instellingen): its own full-page
 * `SecondaryShell` — same one Beheer and Profiel use — with `SettingsNav`
 * as the sole left-hand nav. Hangs off the account menu's Bedrijf context
 * (§ Navigatiemodel, PLAN-FASE2.md WP-08), not one of the main-menu
 * sections.
 */
export function SettingsShell() {
  return <SecondaryShell nav={(onNavigate) => <SettingsNav onNavigate={onNavigate} />} />;
}
